import { fetchCurrentUser } from "../../ducks/user.duck";

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  // await dispatch(fetchCurrentUser())
};
